<template>
  <section class="account-page">
    <page-header></page-header>
    <main>
      <div class="form-box">
        <div class="field">
          <div class="control">
            <input
              v-model="oldpassword"
              class="input"
              type="password"
              placeholder="old password"
            />
          </div>
        </div>
        <div class="field">
          <div class="control">
            <input
              v-model="newpassword"
              class="input"
              type="password"
              placeholder="new password"
            />
          </div>
        </div>
        <div class="field">
          <div class="control">
            <input
              v-model="confirmpassword"
              class="input"
              type="password"
              placeholder="confirmation password"
              @keyup.enter="update"
            />
          </div>
        </div>
        <button
          type="submit"
          class="button is-primary button-submit is-large"
          @click="update"
        >
          CHANGE
        </button>
        <br />
        <br />
        <div class="has-text-danger">{{ error }}</div>
        <div class="has-text-success">{{ success }}</div>
      </div>
    </main>
  </section>
</template>

<script>
import PageHeader from '@/components/PageHeader';

export default {
  name: 'Account',
  components: {
    PageHeader
  },
  data() {
    return {
      oldpassword: '',
      newpassword: '',
      confirmpassword: '',
      error: '',
      success: ''
    };
  },
  methods: {
    update() {
      if (this.oldpassword == '') {
        this.error = 'You need to provide your old password';
        return;
      } else if (this.newpassword == '' || this.newpassword.length < 8) {
        this.error = 'You need to provide a new password with at least 8 chars';
        return;
      } else if (this.newpassword != this.confirmpassword) {
        this.error = "New password and confirmation don't match";
        return;
      } else {
        this.error = '';
      }

      const item = {
        confirmpassword: this.confirmpassword,
        oldpassword: this.oldpassword,
        password: this.newpassword
      };
      this.axiosRequest('put', 'updatemyprofile', item)
        .then(response => {
          console.log(response);
          this.success = 'Password updated with success';
        })
        .catch(error => {
          console.log(error.response.data.message);
          if (error.response.data.message) {
            this.error = error.response.data.message;
          }
        });
    }
  }
};
</script>

<style lang="scss">
.account-page {
  .form-box {
    max-width: 400px;
    margin: 50px auto;

    .button-submit {
      margin-top: 40px;
    }
  }
}
</style>
